import { IAuthUser } from 'auth/types';
import { AccessPermissions } from 'core/enums';
import { hasPermission } from 'router/utils';

import { canAccessCompanySettings } from './permissions';

const isPartfinitiAdmin = (user?: IAuthUser | null): boolean => Boolean(user?.admin);

// Partfiniti admins seed and repair mappings, and they are the only tier that can add or delete
// one, so they reach the page even when they are not a company admin of the active company.
export const canAccessExtractorVendorMapping = (user?: IAuthUser | null): boolean =>
  canAccessCompanySettings(user) || isPartfinitiAdmin(user);

// Mirrors the BE save guard — `isAdministrator() || (isCompanyAdmin && the role resource)` — which
// is a disjunction, not two sequential checks: an admin may edit without holding the resource.
export const canEditExtractorVendorMapping = (user?: IAuthUser | null): boolean =>
  isPartfinitiAdmin(user) ||
  (Boolean(user?.companyAdmin) &&
    hasPermission([AccessPermissions.ACCESS_EDIT_EXTRACTOR_VENDOR_MAPPING], user?.resources ?? []));

export const canAddExtractorVendorMapping = (user?: IAuthUser | null): boolean =>
  isPartfinitiAdmin(user);

export const canRemoveExtractorVendorMapping = (user?: IAuthUser | null): boolean =>
  isPartfinitiAdmin(user);
